import { preprocess, object, string } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

const VoucheredOfferSchema = object({ id: string(), name: string() }, { message: IS_REQUIRED });

export const PartialAwardVouchersSchema = preprocess(
  (data) => data ?? {},
  object({
    voucheredOffer: VoucheredOfferSchema,
  }),
);
